module.exports = __webpack_public_path__ + "img/cpany25.00290168.png";